export const CODING_PASS_SCORE = 70;

export type CodingScoreBreakdown = {
  correctness: number;
  approach: number;
  code_quality: number;
};

export const isPassingCodingScore = (score: number): boolean =>
  score >= CODING_PASS_SCORE;

export const readCodingScoreBreakdown = (
  value: Record<string, unknown>
): CodingScoreBreakdown | undefined => {
  const direct = value.score_breakdown;
  if (direct && typeof direct === "object") {
    const breakdown = direct as Record<string, unknown>;
    if (
      typeof breakdown.correctness === "number" &&
      typeof breakdown.approach === "number" &&
      typeof breakdown.code_quality === "number"
    ) {
      return {
        correctness: breakdown.correctness,
        approach: breakdown.approach,
        code_quality: breakdown.code_quality,
      };
    }
  }

  if (
    typeof value.llm_correctness_score === "number" &&
    typeof value.llm_approach_score === "number" &&
    typeof value.llm_code_quality_score === "number"
  ) {
    return {
      correctness: value.llm_correctness_score,
      approach: value.llm_approach_score,
      code_quality: value.llm_code_quality_score,
    };
  }

  return undefined;
};
